import { IconContainer } from "components/modules/Editors/MemeGenerator/Containers/IconContainer/IconContainer";
import { MemeGeneratorState, MemeIconState } from "store/features/memeGenerator/types";
import { ResizeHandlers } from "./ResizeHandlers/ResizeHandlers";
import { RotateHandler } from "./RotateHandler/RotateHandler";
import { useIcon } from "./useIcon";

interface IconProps {
    icon: NonNullable<MemeGeneratorState["meme"]>["icons"][number];
}

export const Icon = ({ icon }: IconProps) => {
    const { isDownloading, iconContainerRef, iconContainerClick, dragHandlers } = useIcon(icon);
    return (
        <IconContainer
            icon={icon}
            iconContainerRef={iconContainerRef}
            iconContainerClick={iconContainerClick}
            isDownloading={isDownloading}
            dragHandlers={dragHandlers}
        >
            {!isDownloading && icon.state === MemeIconState.ACTIVE && (
                <div>
                    <ResizeHandlers icon={icon} />
                    <div className="flex items-center justify-center absolute top-full left-0 right-0 translate-y-4 cursor-default pointer-events-none">
                        <RotateHandler icon={icon} />
                    </div>
                </div>
            )}
        </IconContainer>
    );
};
